const getStuName = state => {
    return state.stu_name;
}
const getStuNum = state => {
    return state.stu_num;
}
export default {
    getStuName,
    getStuNum
}


//////////////////
// WEBPACK FOOTER
// ./store/getters.js
// module id = null
// module chunks = 